var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 5.11867C15.67 4.78867 12.32 4.61867 8.98 4.61867C7 4.61867 5.02 4.71867 3.04 4.91867L1 5.11867M6.5 4.10867L6.72 2.79867C6.88 1.84867 7 1.13867 8.69 1.13867H11.31C13 1.13867 13.13 1.88867 13.28 2.80867L13.5 4.10867M16.85 8.27867L16.2 18.3487C16.09 19.9187 16 21.1387 13.21 21.1387H6.79C4 21.1387 3.91 19.9187 3.8 18.3487L3.15 8.27867M8.33 15.6387H11.66M7.5 11.6387H12.5",
    stroke: "#F72847",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d09e7fd994e8bdc91d801ac33c5b3d62.svg";
export { ForwardRef as ReactComponent };